import { useState } from "react";
import "./App.css";

function App() {
  const [result , setResult] = useState("");

  const handelClick = (e) => {
    /*علشان لما اجى اضيف ارقام تحفظ الارقام الجديده و القديمه مع بعض  function concat () هتا انا استخدمت  */
    setResult(result.concat(e.target.name));
  }

  const clear = () => {
    setResult("");
  }

  const cir = () => {
    /* result بتحذف اخر عنصر ف  */
    setResult(result.slice(0, -1));
  }

  const calcuoter = () => {
    try {
      if (result.includes("/0")) { /*Error لو قسمت قمسه على الصفر يطلع  */
        setResult("Error"); 
      } else {
        setResult(eval(result).toString()); 
      }
    } catch (error) {
      setResult("Error");
    }
  }

  return (
    <>
      <div className="container bg-white p-3 rounded-lg shadow-lg shadow-slate-300 ">
        <form>
          <input type="text" value={result} />
        </form>
        <div className="ketboard">
          <button onClick={cir} className="joker">cir</button>
          <button onClick={clear}  className="joker">DEL</button>
          <button onClick={handelClick} name="%" className="joker">%</button>
          <button onClick={handelClick} name="/" className="joker">/</button>
          <button onClick={handelClick} name="7">7</button>
          <button onClick={handelClick} name="8">8</button>
          <button onClick={handelClick} name="9">9</button>
          <button onClick={handelClick} name="*" className="joker">*</button>
          <button onClick={handelClick} name="4">4</button>
          <button onClick={handelClick} name="5">5</button>
          <button onClick={handelClick} name="6">6</button>
          <button onClick={handelClick} name="-" className="joker">-</button>
          <button onClick={handelClick} name="1">1</button>
          <button onClick={handelClick} name="2">2</button>
          <button onClick={handelClick} name="3">3</button>
          <button onClick={handelClick} name="+" className="joker">+</button>
          <button onClick={handelClick} name=".">.</button>
          <button onClick={handelClick} name="0">0</button>
          <button className="bg-pink-800" id="equil" onClick={calcuoter}>=</button>
        </div>
      </div>
    </>
  );
}

export default App;
